// ADDENDUM 30 (E36) B — qué operaciones se ven cuando hay búsqueda o filtro de estado.
//
// La regla vive en un módulo PURO y se prueba aquí y no montando el bloque: ejercerla desde el
// componente exigiría una fixture con decenas de filas para probar lo mismo que se prueba sin ella,
// y el bloque ya tiene sus propios tests para lo que SÍ es suyo (que el chip se pulsa, que el
// contador se pinta, que la tabla se queda vacía con su frase).
//
// ⚠️ LO QUE ESTE MÓDULO NO DECIDE: aquí no hay `t_`. Devuelve filas y números; el texto lo pone
// quien pinta. Es la misma separación de `operationNameLabel.js` y por la misma razón.

import { operationCodeAndName } from './operationNameLabel'

/**
 * Minúsculas y SIN TILDES.
 *
 * Buscar "soldadura" tiene que encontrar "Soldadúra", y al revés. Los nombres de operación los
 * escriben personas en el editor de workflow, así que la tilde es tan probable como su ausencia y
 * exigir que el que busca acierte con ella convierte el buscador en un juego de adivinar.
 */
const plain = (value) => String(value === null || value === undefined ? '' : value)
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .toLowerCase()
  .trim()

/**
 * ¿Coincide la operación con lo tecleado?
 *
 * Busca en CÓDIGO y en NOMBRE, que es la regla simétrica del addendum 20: ninguno de los dos es el
 * eje. Una operación con solo código se encuentra por su código, y una con solo nombre por su
 * nombre — es exactamente el mismo par que la fila enseña, leído del mismo sitio (`operationCodeAndName`),
 * así que no se puede buscar algo que no esté a la vista ni al revés.
 */
export const operationMatchesSearch = (operation, search) => {
  const term = plain(search)
  if (term === '') return true
  const { code, name } = operationCodeAndName(operation)
  return plain(code).includes(term) || plain(name).includes(term)
}

/**
 * Las filas visibles y el recuento, en una sola pasada.
 *
 * Devuelve `total` además de las filas porque la indicación cuenta SOBRE EL TOTAL —"14 de 30", no
 * "14 de 14"— y esa es justo la cifra que se pierde si quien pinta solo recibe la lista ya
 * filtrada. Que salgan de la misma función es lo que impide que el número y la tabla se
 * contradigan.
 *
 * ⚠ `hidden` se retiró con los chips: la indicación de ahora dice "N de M" y la resta la hace quien
 * lee. Devolver un tercer número que nadie usa es cobertura que nadie puede probar.
 *
 * @returns {{rows: Array, total: number, shown: number}}
 */
export const filterOperations = (operations, search) => {
  const source = Array.isArray(operations) ? operations : []
  const rows = source.filter((operation) => operationMatchesSearch(operation, search))
  return { rows, total: source.length, shown: rows.length }
}
